import { Navigate } from "react-router";
import { useTsTmcProviderRestrictionPolicy } from "@/hooks/useTsTmcProviderRestriction";

const withTsTmcPatientListGuard = (Component: React.ComponentType) => {
  return function TsTmcPatientListGuarded() {
    const policy = useTsTmcProviderRestrictionPolicy();

    if (policy.hidePatientList) {
      return <Navigate to="/" replace />;
    }

    return <Component />;
  };
};

export default withTsTmcPatientListGuard;
